/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerListTagResponse } from "./BlogManagerListTagResponse";

export type BlogManagerListTagResponseApiRespoonse = {
  data?: BlogManagerListTagResponse;
  status?: BlogManagerListTagResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace BlogManagerListTagResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
